const {
  createReducer,
  createSlice,
  createAsyncThunk,
} = require("@reduxjs/toolkit");
const { useSelector } = require("react-redux");
const { postLike } = require("./likeAPI");

// const { post } = useSelector((state) => state.post);
// const { likes } = post;

const initialState = {
  loading: false,
  error: "",
  likes: 0,
};

export const likePost = createAsyncThunk(
  "like/patchLikes",
  async ({ id, likes }) => {
    const increasedLike = await postLike({ id, likes });
    return increasedLike;
  }
);

const likeReducer = createSlice({
  name: "like",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(likePost.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(likePost.fulfilled, (state, action) => {
        state.loading = false;
        state.likes = action.payload;
      })
      .addCase(likePost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error?.message;
        state.likes = 0;
      });
  },
});

export default likeReducer.reducer;
